import { Wrench } from 'lucide-react';
import { fsmGet } from '../../api/api';
import LiveDashboardPage from './LiveDashboardPage';

export default function FSMDashboardPage() {
  return <LiveDashboardPage title="FSM" description="Field Service Management" icon={Wrench} getData={fsmGet} />;
}